import { Injectable, inject } from '@angular/core';
import { BaseProvider } from '../../shared/providers/base-provider';
import { UbigeoNotifier } from '../notifiers/ubigeo-notifier';
import { UbigeoState } from '../states/ubigeo-state';

@Injectable({ providedIn: 'root' })
export class UbigeoProvider extends BaseProvider<UbigeoNotifier, UbigeoState> {
  constructor() {
    super(UbigeoNotifier);
  }
}
